/* src/app/system-view/main-dashboard/table-card/table-card-configuration/table-card-configuration.component.scss */
.configuration-fields {
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;
  overflow: auto;
  padding: var(--tem-space-2);
}
.grid-face {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
}
form {
  display: flex;
  flex-direction: column;
  height: 100%;
  gap: var(--tem-space-3);
}
nz-form-item {
  width: 100%;
  margin-bottom: var(--tem-space-2);
}
.content {
  position: relative;
  display: flex;
  flex-direction: column;
  font-size: var(--tem-fs-sm);
  height: 100%;
}
.more-options {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  align-items: center;
  gap: var(--tem-space-4);
}
.switch-option {
  display: inline-flex;
  align-items: center;
  gap: var(--tem-space-2);
  cursor: pointer;
  color: var(--tem-ink);
}
.more-options-color {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: var(--tem-space-2);
}
.color-formula {
  min-height: 120px;
  resize: vertical;
  font-family:
    "Consolas",
    "Menlo",
    monospace;
  font-size: var(--tem-fs-sm);
}
.help-icon {
  cursor: pointer;
  color: var(--tem-muted);
}
.help-icon:hover {
  color: var(--tem-deep);
}
.fields-grid {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 240px;
  overflow: auto;
  padding-top: var(--tem-space-1);
}
.fields-toolbar {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  gap: var(--tem-space-1);
  padding: var(--tem-space-2);
  border: 1px solid var(--tem-border);
  border-radius: var(--tem-radius);
  background: var(--tem-surface-2);
}
.fields-toolbar__spacer {
  flex: 1;
}
.fields-toolbar__derive {
  color: var(--tem-warn);
  border-color: var(--tem-warn);
}
/*# sourceMappingURL=table-card-configuration.component.css.map */
